Livewire.on('showAlert', (title, icon, text, showCancel, showConfirm, toast) => {
    Swal.fire({
        title: title,
        icon: icon,
        text: text,
        showConfirmButton: showConfirm,
        showCancelButton: showCancel,
        cancelButtonText: 'Nein',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ja',
        cancelButtonColor: '#d33',
        toast: toast,
        position: toast ? 'top-end' : 'center',
        timer: toast ? 3000 : null,
        timerProgressBar: toast,
    })
});
